/* eslint-disable comma-dangle */
/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import './index.css';

// import { ThemeProvider } from '@mui/material/styles';
import { EventType, PublicClientApplication } from '@azure/msal-browser';

// import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { msalConfig } from './authConfig';
import reportWebVitals from './reportWebVitals';

// import theme from './theme';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const { account } = event.payload;
    msalInstance.setActiveAccount(account);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter
    basename={
      process.env.REACT_APP_ENVIRONMENT === 'UAT' ? '/chatbot-fe' : '/route'
    }
  >
    <App instance={msalInstance} />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
